import { Component, Input, Output, EventEmitter } from '@angular/core';
import { xtwhUrls } from '@shared/urls/xtwhUrls';
import { HttpClient } from '@angular/common/http';
import { NzMessageService } from 'ng-zorro-antd';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { generateFormData } from '@shared/utils/publicMethods';
import { Observable, Observer } from 'rxjs';
import { phoneValidator } from '@shared/validator/validators';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.less'],
})
export class BaseComponent {
  constructor(private http: HttpClient, private msg: NzMessageService, private fb: FormBuilder) {
    this.validateForm = this.fb.group({
      userName: [''],
      sex: [''],
      phone: ['', [Validators.required, phoneValidator]],
      email: ['', [Validators.required, Validators.email]],
      profile: [''],
    });
  }

  @Input() userInfo: any;
  @Output() private refresh = new EventEmitter();
  avatarUrl: string;
  spinning: boolean;

  validateForm: FormGroup;

  updatePersonalDetails(): void {
    this.spinning = true;
    this.http
      .post(
        xtwhUrls.userConfig.updUserDetail,
        generateFormData({
          phone: this.userInfo.phone,
          email: this.userInfo.email,
          profile: this.userInfo.profile,
        }),
      )
      .subscribe((response: any) => {
        this.spinning = false;
        if (response.err_code === 2000) {
          this.msg.success(response.err_msg);
        } else {
          this.msg.error(response.err_msg);
        }
      });
  }

  // 头像上传
  avatarBeforeUpload = (file: File) => {
    console.log('开始上传, ', file);
    return new Observable((observer: Observer<boolean>) => {
      const isJPG = file.type === 'image/jpg';
      const isJPEG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      if (!isJPG && !isJPEG && !isPNG) {
        this.msg.create('error', '请上传正确格式图片（.jpg/.jpeg/.png）');
        observer.complete();
        return;
      }
      const isSize = file.size / 1024 / 1024 < 2;
      if (!isSize) {
        this.msg.create('error', '默认头像图片大小不能大于2M');
        observer.complete();
        return;
      }
      this.http.post(xtwhUrls.files.uploadFile_icon, generateFormData({ file })).subscribe((res: any) => {
        if (res.err_code === 2000) {
          this.spinning = true;
          this.avatarUrl = `${xtwhUrls.files.downloadFile_icon}?fileName=${res.avatarId}`;
          // 调用用户修改个人头像接口
          this.http
            .post(xtwhUrls.userConfig.updAvatar, generateFormData({ avatarId: res.fileName }))
            .subscribe((response: any) => {
              this.spinning = false;
              if (response.err_code === 2000) {
                this.msg.create('success', response.err_msg);
                this.refresh.emit(null);
              } else {
                this.msg.create('error', response.err_msg);
              }
            });
          observer.complete();
        } else {
          this.msg.create('error', res.err_msg);
          observer.complete();
        }
      });
    });
  };
}
